import {createApp} from 'vue';
import App from './App.vue';
import router from './router.js';
import VTooltip from 'v-tooltip';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue3-cookies';
import 'bootstrap/dist/js/bootstrap.js';
import store from './store/index.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';

const app = createApp(App);
app.use(VTooltip)
.use(VueCookies)
.use(router)
.use(VueAxios, axios)
.use(store)
router.app = app;
app.mount('#app');

axios.interceptors.request.use((config) => {
    const user = localStorage.getItem("user");
    if (user) {
        const token = localStorage.getItem("accessToken");
        const authToken = token;
        if (authToken) {
            config.baseURL = process.env.VUE_APP_URL;
            if(config.url !== process.env.VUE_APP_AEM_URL + '/bin/mchp/fragmentexport.header.js' && config.url !== process.env.VUE_APP_LIVE_CHAT_URL + '/bin/mchp/fragmentexport.chat.js' && config.url !== process.env.VUE_APP_AEM_URL + '/bin/mchp/fragmentexport.footer.js') {
                config.headers.Authorization = `Bearer ${authToken}`;
            }
        }
    }
    return config;
},
    (err) => {
        console.log(err);
    });
